// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal_modal__14tB-","closeButton":"modal_closeButton__GP740"};